module.exports = __webpack_public_path__ + "static/media/choose-account.5dd19a56.jpg";